/* eslint-disable @typescript-eslint/no-var-requires */
import React, {
  FunctionComponent,
  // MutableRefObject,
  useEffect,
  // useRef,
} from 'react';

import './animation009.less';
// import { usePlayFlag } from './../../components/topicScroll';
import useIntersectionObserver from '../../../../../hooks/useIntersectionObserver';

interface IAnimation009Item {
  icon: string;
  color: string;
  text: string;
}

interface IAnimation009Props {
  items: IAnimation009Item[];
  onCompleted: () => void;
}

const Animation009: FunctionComponent<IAnimation009Props> = ({
  items,
  onCompleted,
}) => {
  // const crrRef = useRef() as MutableRefObject<HTMLDivElement>;
  // const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const { targetRef, isVisible } = useIntersectionObserver({
    threshold: 0.5, // 元素 30% 进入视口时触发
    rootMargin: '-50px', // 根边距缩小 50px（需元素进入视口 50px 后才判定）
  });
  const [play, setPlay] = React.useState(1);
  const startPlay = (next = 1) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1200);
    } else {
      console.log('Animation009 onCompleted');
      onCompleted && onCompleted();
    }
  };
  const getImg = (img: string) =>
    require(`../../../../../assets/${img}`).default;

  useEffect(() => {
    if (isVisible) {
      startPlay();
    }
  }, [isVisible]);
  return (
    <div
      ref={targetRef}
      className="animation009 component"
      style={{ margin: 0 }}
    >
      <div className="animation009-content">
        {items.map((itm: IAnimation009Item, idx: number) => (
          <div
            key={idx}
            className={`animation009-item animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
            style={{
              width: `${(1 / items.length) * 100}%`,
              color: itm.color,
            }}
          >
            <div className="animation009-indicate">
              <div
                className="animation009-icon"
                style={{ backgroundColor: itm.color }}
              >
                <img src={getImg(itm.icon)} alt="" />
              </div>
              <div className="animation009-indicate-number">0{idx + 1}</div>
            </div>
            <div
              className="animation009-text"
              dangerouslySetInnerHTML={{ __html: itm.text }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Animation009;
